import * as React from "react"

const Mute = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        viewBox="0 0 512 512"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
    >
        <path d="M0 149.3v213.3h85.3L234.6 512V0L85.3 149.3H0Z" fill="currentColor" />
        <rect
            width={268.204}
            height={43.414}
            rx={0}
            ry={0}
            transform="rotate(45 -12.172 491.788) scale(.88489 1.26667)"
            fill="currentColor"
        />
        <rect
            width={268.204}
            height={43.414}
            rx={0}
            ry={0}
            transform="matrix(-.62571 .62571 -.89567 -.89567 512 191.533)"
            fill="currentColor"
        />
    </svg>
)

export default Mute;
